import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles((theme: any) => ({
    tableContainer: {
        width: '100%',
        overflowX: 'auto',
    },
    deviceCell: {
        maxWidth: '260px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    scoreBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
    perfGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '8px',
        marginBottom: '12px',
    },
    perfCard: {
        padding: '10px 14px',
        backgroundColor: theme.palette.action.hover,
        borderRadius: '8px',
        border: `1px solid ${theme.palette.divider}`,
        textAlign: 'center',
    },
    sectionTitle: {
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        paddingBottom: '4px',
        marginBottom: '12px',
    },
    preBlock: {
        backgroundColor: theme.palette.action.hover,
        borderRadius: '6px',
        padding: '12px',
        fontFamily: 'monospace',
        fontSize: '0.8rem',
        overflowX: 'auto',
        maxHeight: '400px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
    },
    imageThumb: {
        maxWidth: '120px',
        maxHeight: '120px',
        objectFit: 'contain',
        borderRadius: '4px',
        border: `1px solid ${theme.palette.divider}`,
        cursor: 'pointer',
    },
}));
